module.exports = __webpack_public_path__ + "static/media/img3.f2e4e15a.jpeg";